"use client";
import { LinkButton } from "@std/componentry/Standard";
import { Carousel, EmptyCarousel } from "./Carousel";
import { Loading } from "../Feeds/Feed";

import {
  useClientShorts,
  useClientThumbnails,
  useClientVideos,
} from "@std/@/kooleyy/hooks/client";

export const BaseCarousel = ({ id, type, hits }) => {
  const capitalisedType = type.charAt(0).toUpperCase() + type.slice(1);
  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex flex-row items-center gap-x-4">
        <span className="text-3xl font-bold">{capitalisedType}s</span>
        <LinkButton href={`/clients/${id}/${type}s`}>More</LinkButton>
      </div>
      <Carousel
        data={hits?.hits?.map((r) => r._source)}
        total={hits?.total?.value}
      />
    </div>
  );
};

export const SkeletonCarousel = () => {
  const k = [...Array(5).keys()];
  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex flex-row items-center gap-x-4">
        <div className="w-64 h-10 bg-gray-500 rounded-full animate-pulse" />
        <div className="w-16 h-8 bg-gray-500 rounded-full animate-pulse" />
      </div>
      <EmptyCarousel
        items={k.map((_, i) => (
          <Loading key={i} />
        ))}
      />
    </div>
  );
};

export const VideoCarousel = ({ id }) => {
  const [hits, hitsPending] = useClientVideos({ id });

  if (hitsPending) return <SkeletonCarousel id={id} type={"video"} />;

  if (hits?.hits?.length === 0) return null;

  return <BaseCarousel id={id} type={"video"} hits={hits} />;
};

export const ThumbnailCarousel = ({ id }) => {
  const [hits, hitsPending] = useClientThumbnails({ id });

  if (hitsPending) return <SkeletonCarousel id={id} type={"thumbnail"} />;

  if (hits?.hits?.length === 0) return null;

  return <BaseCarousel id={id} type={"thumbnail"} hits={hits} />;
};

export const ShortCarousel = ({ id }) => {
  const [hits, hitsPending] = useClientShorts({ id });

  if (hitsPending) return <SkeletonCarousel id={id} type={"short"} />;

  if (hits?.hits?.length === 0) return null;

  return <BaseCarousel id={id} type={"short"} hits={hits} />;
};
